import React from 'react'
import { TextField, Button, FormControl, Grid } from '@mui/material';

import { CustomAutocomplete, LinearLoading } from 'common'

export const ExpensesForm = ({ useFetchInit, readOnlyMode }) => {

    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormOtherExpense } = Forms
    const { formState, onInputChange, onInputNumberChange, onSelectSearchChange } = FormOtherExpense
    
    // ------------------------------------------------ FetchData
    const { fetchOtherExpenses, fetchSpecificExpenseReception } = FetchData
    const { dataOtherExpenses } = fetchOtherExpenses
    const { loadingFetchSpecificExpenseReception } = fetchSpecificExpenseReception
    
    // ------------------------------------------------ Actions
    const { onSubmitOtherExpensesForm, handleClickResetOtherExpenseForm } = Actions

    return (
        <>
            <div className='h4 mt-1 mb-1'>
                {formState.idexpensereception > 0
                    ? 'Actualizar Registro'
                    : 'Crear Registro'}
            </div>
            <div className="border-bottom border-dark"></div>
            {loadingFetchSpecificExpenseReception && ( <LinearLoading /> )}

            <div className="pt-2"></div>
            <form onSubmit={onSubmitOtherExpensesForm}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="idexpense">* Descripcion</label>
                            <CustomAutocomplete 
                                customId="idexpense"
                                customName="idexpense"
                                customValue={formState.idexpense}
                                customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idexpense', value: value.value }})}
                                customPlaceholder='Selecciona una opcion'
                                customOptions={
                                    dataOtherExpenses.map(({ idexpense, descripcion }) => ({
                                        value: idexpense,
                                        name: descripcion
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled={readOnlyMode}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="costo">* Costo</label>
                            <TextField
                                id="costo"
                                name="costo"
                                value={formState.costo}
                                onChange={onInputNumberChange}
                                // label='Marca'
                                size='small'
                                type="number"
                                step="0.01"
                                variant="outlined"
                                hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-2"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl fullWidth>
                            <label htmlFor="observation">Observaciones</label>
                            <TextField
                                id="observation"
                                name="observation"
                                value={formState.observation}
                                onChange={onInputChange}
                                // label='Modelo'
                                size='small'
                                multiline
                                rows={3}
                                type="text"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <div className="pt-4"></div>
                <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>                
                    <Grid item xs={12}>
                        <div className="text-center">
                            <Button
                                style={{background: "#4b4b4c"}}
                                variant="contained"
                                type='submit'
                                disabled={readOnlyMode}
                            >
                                <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                            </Button>
                            &nbsp; &nbsp;
                            <Button 
                                style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                type='button'
                                variant="contained"
                                onClick={handleClickResetOtherExpenseForm}
                                disabled={readOnlyMode}
                            >
                                <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                            </Button>
                            
                        </div>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}
